import "./carousel.css"
import "react-image-gallery/styles/css/image-gallery.css"
import ImageGallery from "react-image-gallery"
var React = require("react")
var ReactDOM = require("react-dom")

export default class ImageViewer extends React.Component {
  constructor() {
    super()
    this.state = {
      value: 0,
    }
  }

  onChange = value => this.setState({ value })

  render() {
    console.log("list", this.props)
    const images = this.props.images.map(img => {
      return {
        original: img,
        thumbnail: img,
      }
    })
    return (
      <ImageGallery
        items={images}
        disableSwipe={true}
        startIndex={this.props.currentIndex}
      />
    )
  }
}

// export default ImageViewer
